import { Role } from 'shared/models';
import { Dictionary } from "lodash";

export const Actions = {
    GET_ROLES_REQUEST: 'GET_ROLES_REQUEST',
    GET_ROLES_SUCCESS: 'GET_ROLES_SUCCESS',
    GET_ROLES_FAILURE: 'GET_ROLES_FAILURE',
};

export const getRolesRequest = () => ({
    type: Actions.GET_ROLES_REQUEST,
});
export const getRolesSuccess = (roles: Dictionary<Role>) => ({
    type: Actions.GET_ROLES_SUCCESS,
    payload: roles,
});
export const getRolesFailure = (error: Error) => ({
    type: Actions.GET_ROLES_FAILURE,
    payload: error,
    error: true,
});
